var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.state.selectedUri)?_c('object',{staticClass:"w-100 h-100",attrs:{"type":"application/pdf","data":_vm.state.selectedUri}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }